import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Button from 'components/ui/Button';

import { logger } from '../utils/logger';

const NotFound = () => {
  const navigate = useNavigate();

  React.useEffect(() => {
    // Log 404 for monitoring
    logger?.warn('404 Page Not Found', { 
      path: window.location?.pathname,
      referrer: document.referrer 
    });
  }, []);

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <>
      <Helmet>
        <title>Page Not Found - MyBodyToday</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      
      <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
        <div className="text-center max-w-md">
          <div className="flex justify-center mb-6">
            <div className="relative">
              <h1 className="text-9xl font-bold text-primary opacity-20">404</h1>
            </div>
          </div>

          <h2 className="text-2xl font-medium text-foreground mb-2">Page Not Found</h2>
          <p className="text-muted-foreground mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              variant="default"
              iconName="ArrowLeft"
              iconPosition="left"
              onClick={() => window.history?.back()}
            >
              Go Back
            </Button>

            <Button
              variant="outline"
              iconName="Home"
              iconPosition="left"
              onClick={handleGoHome}
            >
              Back to Home
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NotFound;
